/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../common/forms/forms.ts" />
/// <reference path="../../../teva/positioning/positioning.ts" />

namespace OfficeGuy.Apps {
    export class POS {
        static Init(DefaultProduct) {
            POS.RefreshTotal();
            POS.BuildKeypad(".og-pos-occasional-keypad", "הוספה", function () {
                POS.AddOccasionalItem(DefaultProduct);
            });
            POS.RefreshPaymentMethod(true);
            $(".og-pos-main-received input")
                .off("input")
                .on("input", POS.RefreshTotal);

            $(".og-pos-occasional-price input")
                .addClass("ltr_near")
                .off("keup")
                .on("keyup", function (Event) {
                    $(this).attr("type", "number");
                    if (Event.key == "Enter") {
                        POS.AddOccasionalItem(DefaultProduct);
                        return false;
                    }
                });
        }
        static RefreshPaymentMethod(IsInit: boolean): void {
            var $PaymentMethodInput = $("#ChargePaymentDetails_PaymentDetails_PaymentMethod");
            var PaymentMethod = $PaymentMethodInput.val();
            if (IsInit && PaymentMethod == "Existing" && $PaymentMethodInput.find("option").length == 2 && $PaymentMethodInput.find("option").first().text() == "") {
                PaymentMethod = $($PaymentMethodInput.find("option")[1]).val();
                $PaymentMethodInput.val(PaymentMethod);
            }
            var ExistingPaymentMethodIsCC = PaymentMethod == "Existing" && $PaymentMethodInput.hasClass("existing-iscc");

            Forms.ToggleDisableForm($(".og-billing-charge-paymentmethod-setactive"), PaymentMethod != "Existing");
            Forms.ToggleDisableForm($('.og-billing-charge-paymentmethod-creditcard-number, .og-billing-charge-paymentmethod-creditcard-expiration, .og-billing-charge-paymentmethod-creditcard-customerid'), PaymentMethod == "CreditCard");
            Forms.ToggleDisableForm($('.og-billing-charge-paymentmethod-creditcard-cvv'), PaymentMethod == "CreditCard" || ExistingPaymentMethodIsCC);
            $('.og-billing-charge-paymentmethod-creditcard-number, .og-billing-charge-paymentmethod-creditcardswipe-track2').closest(".sumit-field-horizontalcontainer");
            Forms.ToggleDisableForm($('.og-billing-charge-paymentmethod-creditcardswipe-track2, .og-billing-charge-paymentmethod-creditcardswipe-cvv, .og-billing-charge-paymentmethod-creditcardswipe-citizenid'), PaymentMethod == "CreditCardSwipe");

            var $SelectBoxInput = $(".og-billing-charge-paymentmethod input:hidden");
            if ($SelectBoxInput.length == 0)
                return;

            var SelectBox = Teva.SelectBox.GetInstance($SelectBoxInput);
            var ValidValuesCount = 0;
            var ValidValue = null;
            for (var i = 0; i < SelectBox.SelectConvertedResults.length; i++)
                if (SelectBox.SelectConvertedResults[i].text != "") {
                    ValidValuesCount++;
                    ValidValue = SelectBox.SelectConvertedResults[i];
                }
            if (ValidValuesCount == 1)
                SelectBox.SetValue(ValidValue.id, ValidValue.text, ValidValue.data);
            $(".og-billing-charge-paymentmethod-method").toggle(ValidValuesCount != 1);
        }
        static ShowCash() {
            var Total = Number($(".og-pos-main-summary:first").text());
            if (isNaN(Total) || Total == 0)
                return false;

            var $Modal = OfficeGuy.Modals.ShowHTMLDialog({
                Title: 'קבלת תשלום במזומן',
                HTML: $(".og-pos-cash")
            });
            $(".og-pos-received input").val("");
            POS.RefreshTotal();
            POS.BuildKeypad($Modal.find(".og-pos-received-keypad"));
            return false;
        }
        static ShowCreditCard() {
            var Total = Number($(".og-pos-main-summary:first").text());
            if (isNaN(Total) || Total == 0)
                return false;

            OfficeGuy.Modals.ShowHTMLDialog({
                Title: 'קבלת תשלום באשראי',
                HTML: $(".og-pos-creditcard")
            });
            POS.RefreshTotal();
            return false;
        }
        static BuildKeypad(KeypadElement, SubmitText?, SubmitEvent?) {
            if ($(KeypadElement).children().length != 0)
                return;
            $(KeypadElement)
                .append($(document.createElement('div'))
                    .addClass("teva-keypad-actions")
                    .append(POS.BuildKeyPad_Digit("<span class=\"icon-backspace\"></span>", "Back"))
                    .append(POS.BuildKeyPad_Digit("איפוס", "Clear"))
                    .append(SubmitText == null ? null : POS.BuildKeyPad_Digit(SubmitText, "Submit", SubmitEvent))
                )
                .append($(document.createElement('div'))
                    .addClass("teva-keypad-digits")
                    .append(POS.BuildKeyPad_Digit("7"))
                    .append(POS.BuildKeyPad_Digit("8"))
                    .append(POS.BuildKeyPad_Digit("9"))
                    .append(POS.BuildKeyPad_Digit("4"))
                    .append(POS.BuildKeyPad_Digit("5"))
                    .append(POS.BuildKeyPad_Digit("6"))
                    .append(POS.BuildKeyPad_Digit("1"))
                    .append(POS.BuildKeyPad_Digit("2"))
                    .append(POS.BuildKeyPad_Digit("3"))
                    .append(POS.BuildKeyPad_Digit(".", "Period"))
                    .append(POS.BuildKeyPad_Digit("0"))
                    .append(POS.BuildKeyPad_Digit("+/-", "Sign"))
                );
        }
        static BuildKeyPad_Digit(HTML, Action = null, Event = null) {
            return $(document.createElement('div'))
                .addClass("teva-keypad-button")
                .append($(document.createElement('div'))
                    .addClass("teva-keypad-button-action")
                    .addClass(Action == "Submit" ? "og-button-color-orange" : "og-button-color-default")
                    .data("og-pos-action", Action)
                    .html(HTML)
                    .click(function (ClickEvent) {
                        if (Event != null)
                            Event();
                        else
                            POS.BuildKeyPad_Click(ClickEvent);
                    })
                );
        }
        static BuildKeyPad_Click(ClickEvent) {
            var $ClickTarget = $(ClickEvent.target);
            var $Input = $("input[name=" + $ClickTarget.closest(".teva-keypad").data("target") + "]");
            var InputValue = <string>$Input.val();
            if ($ClickTarget.data("og-pos-action") == "Clear")
                $Input.val("").trigger("change");
            else if ($ClickTarget.data("og-pos-action") == "Back")
                $Input.val(InputValue.substring(0, Math.max(0, InputValue.length - 1))).trigger("change");
            else if ($ClickTarget.data("og-pos-action") == "Sign")
                $Input.val(-Number(InputValue)).trigger("change");
            else if ($ClickTarget.data("og-pos-action") == "Period") {
                if (InputValue.indexOf('.') == -1) {
                    $Input.attr("type", "text");
                    $Input.val(InputValue + ".");
                }
            }
            else
                $Input.val(InputValue + $ClickTarget.text()).trigger("change");
        }
        static RefreshTotal() {
            var Total = 0;
            $(".items .og-pos-main-total").each(function () {
                Total += Number(this.innerText);
            });
            $(".og-pos-main-summary").text(Common.RoundTwoPoints(Total));

            var ReceivedValue = <string>$(".modal .og-pos-main-received input").val();
            var Received = Number(ReceivedValue);
            if (ReceivedValue == null || ReceivedValue.length == 0 || Received == 0)
                $(".modal .og-pos-main-change").text("לא הוזן סכום שהתקבל");
            else
                $(".modal .og-pos-main-change").text(Common.RoundTwoPoints(Received - Total));
        }

        static FindLine(ProductID, UnitPrice) {
            return $(".items tr").filter(function () {
                var $Line = $(this);
                if ($Line.find(".og-pos-main-item input").val() != ProductID)
                    return false;
                if ($Line.find(".og-pos-main-unitprice input").val() != UnitPrice)
                    return false;
                return true;
            }).first();
        }
        static CustomerSelected($EntityPicker): void {
            var SelectBox = Teva.SelectBox.GetInstance($EntityPicker);
            var Data = SelectBox.SelectedData;
            if (Data != null && Data.AdditionalFields && Data.AdditionalFields["Customers.CustomersSuppliers.EmailAddress"])
                $(".og-pos-customer input").val(Data.AdditionalFields["Customers.CustomersSuppliers.EmailAddress"]).trigger("change");
        }

        static ItemSelected($EntityPicker): void {
            var SelectBox = Teva.SelectBox.GetInstance($EntityPicker);
            var Data = SelectBox.SelectedData
            var CompanyValue = "";
            if (Data && Data.AdditionalFields && Data.AdditionalFields["Accounting.IncomeItems.Price"] != "") {
                CompanyValue = Data.AdditionalFields["Accounting.IncomeItems.Price"];
                /*if (Accounting.PricesIncludeVAT && Accounting.SelectedCustomer_NoVAT) {
                    if (CompanyValue != "")
                        CompanyValue = Common.RoundTwoPoints(Number(CompanyValue) / (1 + VATRate / 100)).toString();
                }*/
                if ($(".og-pos-occasional-price input").val() == "")
                    $(".og-pos-occasional-price input").val(CompanyValue).trigger("change");
            }
        }
        static AddOccasionalItem(DefaultProduct) {
            var PriceValue = <string>$(".og-pos-occasional-price input").val();
            if (PriceValue.length == 0)
                return;

            var Price = Common.RoundTwoPoints(Number(PriceValue));
            if (isNaN(Price))
                return;

            var Product = Teva.SelectBox.GetInstance($(".og-pos-occasional-product input.entitypicker:hidden"));
            if (Product.SelectedValue == null || Product.SelectedValue == "0")
                return;

            $(".og-pos-occasional-price input").val("").trigger("change");
            POS.AddItem(Product.SelectedValue, Product.SelectedText, 1, Price);
            if (DefaultProduct == 0)
                Product.ClearValue();
            else
                Product.SetValueFromQueryMethod(DefaultProduct);
        }

        static AddItem(ProductID, ProductName, Quantity, UnitPrice) {
            var $Line = POS.FindLine(ProductID, UnitPrice);
            if ($Line.length == 0) {
                $(".og-pos-additem").click();
                $Line = $(".items tr:last");

                $Line.find(".og-pos-main-item div")[0].innerHTML = ProductName;
                $Line.find(".og-pos-main-item input").val(ProductID);

                $Line.find(".og-pos-main-unitprice div")[0].innerText = UnitPrice;
                $Line.find(".og-pos-main-unitprice input").val(UnitPrice);
            }
            else
                Quantity += Number($Line.find(".og-pos-main-quantity input").val());

            $Line.find(".og-pos-main-quantity div")[0].innerText = Quantity;
            $Line.find(".og-pos-main-quantity input").val(Quantity);

            $Line.find(".og-pos-main-total div")[0].innerText = (Quantity * UnitPrice).toString();

            POS.RefreshTotal();
            Teva.Positioning.ScrollToElement($(".og-pos-main"));
            return false;
        }

        static RemoveItem(Element: Element) {
            OfficeGuy.Forms.NestedForm_Remove('.items', 'ChargeItems', $(Element).closest('tr').index());
            $(Element).closest('tr').remove();
            POS.RefreshTotal();
            return false;
        }
    }
}